
<template>
    <div class="row h-100 justify-content-center align-items-center bg-danger text-light" style="background-color: #2f519a;">
        <div class="col-11 col-sm-8">
            <h3>Muchas gracias por tu tiempo, tus respuestas fueron guardadas con éxito!!!</h3>
            <!-- <h1>Resultado:</h1>
            <h2>{{ getTotal }}</h2>
            <p v-if="getTotal >= 100 && getTotal <= 125">
                ¡Su organización tiene los componentes para lograr agilidad! Su lugar de trabajo tiene las herramientas, procesos, inteligencia social, capacidad de recuperación y capacidad para actuar que le permiten aprovechar las oportunidades en un mercado que valora la velocidad. Es una buena noticia, ya que el 81 % de los ejecutivos consultados en un estudio reciente consideran que la agilidad es la característica más importante de las organizaciones exitosas. Para conocer las áreas en las que podría fortalecerse aún más, consulte las preguntas con las que no pudo estar "totalmente de acuerdo" e identifique el componente correspondiente en la tabla que se encuentra a continuación. Si encuentra áreas que desea mejorar, en Dale Carnegie estamos para apoyar los planes de su organización.
            </p>
            <p v-if="getTotal >= 75 && getTotal <= 99">
                Puede estar en el camino correcto para volverse ágil, pero al menos algunas áreas deben fortalecerse para maximizar la capacidad de la organización para identificar y responder a las condiciones cambiantes. Para conocer las áreas en las que podría fortalecerse aún más, consulte las preguntas con las que no pudo estar "totalmente de acuerdo" e identifique los componentes correspondientes en la tabla que se encuentra a continuación. ¿En qué áreas su organización es más sólida? ¿En cuáles obtuvo el puntaje más bajo? En Dale Carnegie podemos ayudarle a priorizar las acciones adecuadas para su organización.
            </p>
            <p v-if="getTotal >= 25 && getTotal <= 74">
                Hay trabajo por hacer si su organización aspira a convertirse en una organización verdaderamente ágil. Hay muchas cosas que pueden inhibir la capacidad de una organización para ser ágil: la burocracia que ralentiza los procesos, las políticas internas que prolongan el proceso de toma de decisiones, los silos que ocultan las causas fundamentales de los problemas y la responsabilidad de las soluciones, y la falta de confianza que dificulta la comunicación, entre otros. Cuando existen estos obstáculos contra la agilidad, la solución no es simple, pero tampoco es imposible. ¿No está seguro por dónde empezar? Estamos para acompañarle en la planeación y ejecución de los programas que impactarán la agilidad en su organización.
            </p> -->
        </div>
    </div>
</template>

<script>
// import { Decimal } from "decimal.js";
// import { mapGetters } from "vuex";

export default {
    // computed: {
    //     getTotal() {
    //         return this.getAnswers.reduce((total, ans) => {
    //             total = new Decimal(total);
    //             let ans_value = new Decimal(ans.answer);
    //             return total.plus(ans_value);
    //         }, 0);
    //     },
    //     ...mapGetters(["getAnswers", "getEvaluation", "getUser"]),
    // },
};
</script>

<style>
</style>
